import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Template } from '@workspaces/models/templates';
import { TemplatePreviewDialogComponent } from '../template-preview-dialog/template-preview-dialog.component';
import { TemplateFileUploadComponent } from '../template-file-upload/template-file-upload.component';
import { TemplateDetailsModalComponent } from '../template-details-modal/template-details-modal.component';
import { WorkspaceTemplateService } from '@workspaces/services/templates.service';

@Component({ template: '' })
export class TemplateElementComponent {
  @Input({ required: true }) template!: Template;

  @Input({ required: true }) isLink = true;

  constructor(
    protected readonly dialog: MatDialog,
    private readonly workspaceTemplateService: WorkspaceTemplateService
  ) {}

  public downloadTemplate(event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    if (!this.template.s3_key) {
      return;
    }

    const extension = this.template.s3_key.split('.').pop();

    this.workspaceTemplateService.generateDownloadUrl(this.template.id, this.template.version).subscribe(res => {
      fetch(res.url)
        .then(resp => (resp.status === 200 ? resp.blob() : Promise.reject('something went wrong')))
        .then(blob => {
          this.triggerDownload(blob, `${this.template.name}.${extension}`);
        });
    });
  }

  private triggerDownload(blob: Blob, filename: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    // Can be a race condiditon, so wait a bit
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  public openPreview(template: Template, event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.dialog.open(TemplatePreviewDialogComponent, {
      data: { template },
      width: '80%',
      maxWidth: '800px',
      maxHeight: '90vh'
    });
  }

  public uploadFile(template: Template, event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.dialog.open(TemplateFileUploadComponent, {
      data: { templateId: template.id, version: template.version },
      width: '80%',
      maxWidth: '800px',
      maxHeight: '90vh'
    });
  }

  public openDetails(template: Template, event: MouseEvent): void {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.dialog.open(TemplateDetailsModalComponent, {
      data: template,
      width: '80%',
      maxWidth: '800px',
      maxHeight: '90vh'
    });
  }
}
